import type { DatacontractsApi } from '@internal/backstage-plugin-datacontracts-backend';
import type { ApiSpecApi } from '@ipen-portal/plugin-api-spec-backend';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';

import { createApiRef } from '@backstage/frontend-plugin-api';

export const apiSpecApiRef = createApiRef<TRPCOptionsProxy<ApiSpecApi>>().with({
  id: 'plugin.ipen.api-spec.api',
});

export const datacontractsApiRef = createApiRef<
  TRPCOptionsProxy<DatacontractsApi>
>().with({
  id: 'plugin.ipen.datacontracts.api',
});
